import React from 'react';
import { Bell, Send, Clock, CheckCircle, TrendingUp, Users } from 'lucide-react';

const NotificationStats = ({ stats }) => {
  if (!stats) return null;

  const statCards = [
    {
      title: 'Total Notifications',
      value: stats.total_notifications || 0,
      icon: Bell,
      color: 'text-[#FF6B00]',
      bgColor: 'bg-orange-100'
    },
    {
      title: 'Envoyées',
      value: stats.notifications_envoyees || 0,
      icon: Send,
      color: 'text-green-600',
      bgColor: 'bg-green-100'
    },
    {
      title: 'Programmées',
      value: stats.notifications_programmees || 0,
      icon: Clock,
      color: 'text-blue-600',
      bgColor: 'bg-blue-100'
    },
    {
      title: 'En attente',
      value: stats.notifications_en_attente || 0,
      icon: CheckCircle,
      color: 'text-yellow-600',
      bgColor: 'bg-yellow-100'
    }
  ];

  return (
    <div className="space-y-4">
      {/* Stats principales */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {statCards.map((stat, index) => {
          const Icon = stat.icon;
          return (
            <div key={index} className="bg-white rounded-lg shadow p-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-gray-600 mb-1">{stat.title}</p>
                  <p className="text-2xl font-bold text-gray-900">{stat.value}</p>
                </div>
                <div className={`${stat.bgColor} p-3 rounded-lg`}>
                  <Icon className={`w-6 h-6 ${stat.color}`} />
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Taux de lecture */}
      <div className="bg-white rounded-lg shadow p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="bg-purple-100 p-3 rounded-lg">
            <TrendingUp className="w-6 h-6 text-purple-600" />
          </div>
          <div>
            <p className="text-sm text-gray-600">Taux de lecture moyen</p>
            <p className="text-2xl font-bold text-gray-900">
              {stats.taux_lecture_moyen || 0}%
            </p>
          </div>
        </div>

        {/* Stats par type */}
        {stats.par_type && stats.par_type.length > 0 && (
          <div className="mt-6">
            <h4 className="text-sm font-medium text-gray-700 mb-3">Par type</h4>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
              {stats.par_type.map((item, index) => (
                <div key={index} className="border border-gray-200 rounded-lg p-3">
                  <p className="text-xs text-gray-600 mb-1">{item.type_notification}</p>
                  <p className="text-lg font-bold text-[#FF6B00]">{item.count}</p>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Stats par priorité */}
        {stats.par_priorite && stats.par_priorite.length > 0 && (
          <div className="mt-6">
            <h4 className="text-sm font-medium text-gray-700 mb-3">Par priorité</h4>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
              {stats.par_priorite.map((item, index) => (
                <div key={index} className="border border-gray-200 rounded-lg p-3">
                  <p className="text-xs text-gray-600 mb-1">{item.priorite}</p>
                  <p className="text-lg font-bold text-blue-600">{item.count}</p>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default NotificationStats;
